import { render, staticRenderFns } from "./AttentionStatus.vue?vue&type=template&id=08bc138e&"
import script from "./AttentionStatus.vue?vue&type=script&lang=js&"
export * from "./AttentionStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports